/**
 * Service-Klasse für das Pushen von Events in den alten dtmApi (legacy)
 *
 * Diese Klasse stellt sicher, dass Events parallel zum neuen GA4 DataLayer
 * auch in der alten newDataLayer Struktur gepusht werden, um Abwärtskompatibilität
 * zu gewährleisten.
 */
export default class LegacyDataLayerService {
    /**
     * Erstellt eine neue LegacyDataLayerService-Instanz
     */
    constructor() {
        this.dataLayerName = 'newDataLayer';
    }

    /**
     * Gibt das Legacy DataLayer-Array zurück oder initialisiert es
     * @returns {Array} Legacy DataLayer-Array
     * @private
     */
    _getDataLayer() {
        if (typeof window === 'undefined') {
            throw new Error('Legacy DataLayer is only available in browser environment');
        }

        if (!window[this.dataLayerName]) {
            window[this.dataLayerName] = [];
        }

        return window[this.dataLayerName];
    }

    /**
     * Generiert eine eindeutige Event-ID
     * @returns {string} Unique event ID in format: timestamp.randomNumber
     * @private
     */
    _generateUniqueEventId() {
        const timestamp = Date.now();
        const randomNumber = Math.floor(Math.random() * 1000000);
        return `${timestamp}.${randomNumber}`;
    }

    /**
     * Pusht ein Event-Objekt in den Legacy DataLayer
     * @param {Object} eventObject - Event-Objekt
     * @returns {Object} Das gepushte Event-Objekt
     */
    push(eventObject) {
        if (!eventObject || typeof eventObject !== 'object') {
            throw new Error('Event object must be an object');
        }

        // Füge eindeutige Event-ID hinzu
        const objectWithEventId = {
            ...eventObject,
            datalayerEventId: this._generateUniqueEventId()
        };

        const dataLayer = this._getDataLayer();
        dataLayer.push(objectWithEventId);

        // Debug-Log für DTM API
        // console.debug("dtmApi (legacy)", objectWithEventId);

        return objectWithEventId;
    }

    /**
     * Gibt die Anzahl der Events im Legacy DataLayer zurück
     * @returns {number} Anzahl der Events
     */
    getEventCount() {
        return this._getDataLayer().length;
    }

    /**
     * Gibt alle Events aus dem Legacy DataLayer zurück
     * @returns {Array} Array aller DataLayer-Einträge
     */
    getAllEvents() {
        return [...this._getDataLayer()];
    }
}
